"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextWrapper = exports.ContextValue = exports.initMenuState = exports.defaultLinkButtonStyle = void 0;
var contextHelpers_1 = require("react-function-helpers/lib/functions/contextHelpers");
var ContextWrapper_1 = __importDefault(require("react-function-helpers/lib/functions/ContextWrapper"));
exports.defaultLinkButtonStyle = {
    variant: 'h6',
    paddingTopBottom: 1,
    paddingLeftRight: 2,
    buttonColor: 'primary',
    buttonVariant: 'contained',
};
exports.initMenuState = {
    linkButtonStyle: exports.defaultLinkButtonStyle,
};
var initReducers = function (state) { return state; };
exports.ContextValue = contextHelpers_1.createContextValueFn(exports.initMenuState, initReducers);
var ContextStore = contextHelpers_1.createContextStore(exports.initMenuState);
exports.default = ContextStore;
exports.ContextWrapper = ContextWrapper_1.default(exports.ContextValue, ContextStore);
